export const projects = [
  {
    id: 1,
    category: 'foodandbeverages',
    title: 'Fitto',
    seoData: {
      title: 'food photography for a fresh produce brand fitto by mudrost',
      description:
        'Vibrant and indulging food photography works for a fresh seeds brand showing the vibrant and juicy texture of tomatoes. High quality food photography for catalogue',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Commercial food photography, vibrant food photography, high quality food photos, indulgent food styling and photography, professional food photography for a catalogue',
      url: 'https://mudrost.in/projectdetails/1'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffnb_fiito_cover.jpg?alt=media&token=6a4ed37a-ad23-4962-b02f-3394e94e7b11',
      bannerAltTxt:
        'Image of juicy red tomatoes by semillas fitto seeds India shot in a professional studio setup, clean and professional lighting.'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffnb_fiito_1.jpg?alt=media&token=b043e23b-9bc5-44cc-a8b0-3a8b6f586f19',
        mediaAltTxt:
          'food photography of juicy red tomatoes kept on a dark background, low key lighting and top light as a highlight on the tomatoes gives it a hero image feel. High quality food photography.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffnb_fiito_2.jpg?alt=media&token=fb41eb02-e889-4c76-b372-ddd3f5be75f0',
        mediaAltTxt:
          'Commercial food photography of red tomatoes stacked on top of each other and kept next to a basket'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffnb_fiito_3.jpg?alt=media&token=0ff6a253-3005-481c-a840-193c280ca1c6',
        mediaAltTxt:
          'High quality vibrant food photography of tomatoes kept on a black background. Soft key lighting on the tomatoes'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffnb_fiito_4.jpg?alt=media&token=5268f98f-e54c-4c9e-8751-f922c9d7e3a3',
        mediaAltTxt:
          'Commercial food photography of vegetables kept on a table, vibrant vegetables still life photography for brand '
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffitto%2Ffitto_seeds_thumbnail.webp?alt=media&token=e790e0f6-d895-493e-b103-38cb4d3f58b0',
    thumbnailAltText:
      'Image of juicy red tomatoes by semillas fitto seeds India shot in a professional studio setup, clean and professional lighting.',
    meta: {
      brand: 'Fitto Seeds',
      'photography & lighting': 'vivek s k',
      'post production': 'vivek s k',
      description:
        'Fitto is all about freshness and our aim throughout the shoot was to evoke that. With a basket of fresh tomatoes at hand, we had to set the stage and sizzle things up. With just a spray bottle and one keylight, we ended up with shots that highlighted the hues of the product.'
    }
  },
  {
    id: 2,
    category: 'foodandbeverages',
    title: 'Fortune',
    seoData: {
      title: 'Ad campaign video shoot for fortune foods by mudrost studio',
      description:
        "Fortune's valentines day campaign celebrates the story of three Indian young couples and their shared love for food. The video, produced end to end by mudrost studio celebrates that bond and fortune's moto of sharing a home cooked meal",
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        "Advertisement video production for a FMCG brand, Fortune foods brand video, fortune foods advertising campaign, valentine's day video shoot, high quality story oriented video shoot, bangalore based creative studio doing ad video production",
      url: 'https://mudrost.in/projectdetails/2'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffortune%2Ffnb_fortune_cover.jpg?alt=media&token=94eb2ea7-f61d-4312-8b15-03665e40ca18',
      bannerAltTxt:
        'Flatlay image of a table spread, one male and female hand reaching out for the rotis, high quality visual from a visual ad campaign'
    },
    media: [
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffortune%2Ffnb_fortune_film_1.mp4?alt=media&token=1997b79c-b795-4235-8df6-a2da530171da',
        mediaAltTxt:
          'Advertisement Video of an Indian couple sitting on a dinner table and looking at their phones, after a moment of sudden interaction they realize the importance of the moment and keeps their phones aside and indulges in enjoying their dinner together.'
      },
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffortune%2Ffnb_fortune_film_2.mp4?alt=media&token=10329248-5d6c-45fd-a195-86682494d5ac',
        mediaAltTxt:
          'A story oriented ad film of fortune food, a young professional male stressed out and engrossed in work,  he gets a text message from his wife reminding of the lunch she packed, after that he opens the message, he pauses and enjoys the home cooked meal'
      },
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffortune%2Ffnb_fortune_film_3.mp4?alt=media&token=98df1f6c-45e5-4716-a5bf-7c037c71518a',
        mediaAltTxt:
          'Fortune foods ad film work where it tells a story of a young couple enjoying a cricket match along with a plate of home cooked snacks, while they are engrossed in the game, only one piece of snack remains and the husband lovingly hands it over to the wife'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffortune%2Ffortune_film1_thumbnail.webp?alt=media&token=a5e9be6e-3282-45c6-b38a-3e72f87fb10f',
    thumbnailAltText:
      'Flatlay image of a table spread, one male and female hand reaching out for the rotis, high quality visual from a visual ad campaign',
    meta: {
      brand: 'fortune foods',
      agency: 'social beat',
      'production house': 'mudrost studio',
      director: 'vivek s k',
      'creative producer': 'noorhanaz khatoon',
      'executive producer': 'naveen tejaswi',
      dop: 'darshan swaroop',
      'editor and vfx': 'noorhanaz khatoon',
      colourist: 'rakesh hosaamani',
      'food stylist and art director': 'kanishka prabhu',
      mua: 'shivanya and vidya',
      cast: 'aishwarya  shankar, abhi das, chakravarthy reddy, swetha sanketh, harish c k',
      description:
        "Love finds its way to the soul through food, and to show this precious bond of love, we  teamed up with Social Beat to bring the Fortune Valentine's Day campaign to life. It was equally exciting yet challenging to tell three beautiful stories that celebrate ‘ghar ka khana’ as the love language."
    },
    clientQuote: {
      clientName: 'Soumyanshu Behera',
      designation: 'Lead - Video & Creative Strategy, Social Beat',
      quote:
        "It's difficult to find a partner who sees a campaign through irrespective of the challenge in hand, we were glad to choose mudrost to help us with our very last minute Valentine's Day campaign which was executed thoroughly and the team ensured to make it look far from last minute. We look forward to working with them in the future, and absolutely appreciate the efforts and the ownership of the project."
    }
  },
  {
    id: 3,
    category: 'foodandbeverages',
    title: 'Casinova',
    seoData: {
      title: 'High quality food photography for biryani by mudrost studio',
      description:
        'biryani food photography in a dark and moody setup, rich Indian menu photography in a professional studio setup.  ',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Commercial food photography, restaurant photography, restaurant menu photography in bangalore, bangalore creative studio doing professional food photography ',
      url: 'https://mudrost.in/projectdetails/3'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Ffnb_gir_cover.jpg?alt=media&token=93763f68-2a73-4452-b4d2-89a51cce56d7',
      bannerAltTxt: 'Image of a chicken biryani kept on a bowl and in a moody kitchen setup'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Ffnb_gir_1.jpg?alt=media&token=0d7fe0a3-a0a6-456b-891e-54ad623724ce',
        mediaAltTxt:
          'top angle shot of chicken biryani styled and arranged for a menu display. Chicken biryani styled with raita and gravy'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Ffnb_gir_2.jpg?alt=media&token=df7e1a5a-bc54-40fc-b848-6eace41ea96b',
        mediaAltTxt:
          'flat lay food photography of fish and chips kept on a grey tray, high quality image of the food for a restaurant menu shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Ffnb_gir_3.jpg?alt=media&token=4327da53-77dc-4a62-9106-8fced1ada4b1',
        mediaAltTxt: 'High quality image of chicken tikka kept on a table, restaurant menu shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Ffnb_gir_4.jpg?alt=media&token=0d192c27-30cb-4e67-8f4d-08f4599c6048',
        mediaAltTxt: 'styled food image of a baby corn masala kept on a kadhai, top down shot, flatlay food shot'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fgir%2Fgir_thumbnail.webp?alt=media&token=973295ef-82a9-4a68-bfff-05c429440151',
    thumbnailAltText: 'Image of a chicken biryani kept on a bowl and in a moody kitchen setup',
    meta: {
      brand: 'Casinova',
      'photography & lighting': 'vivek s k',
      'post production': 'vivek s k',
      description:
        'Casinova is all about bold, vibrant flavours. To bring that essence to life in the photographs, we infused our set design with the spices and ingredients that make their dishes special. It’s like capturing a culinary symphony where every shot celebrates both the food and its flavorful story.'
    }
  },
  {
    id: 4,
    category: 'foodandbeverages',
    title: 'Roma',
    seoData: {
      title: 'Premium food photography for a Italian restaurant by mudrost studio',
      description:
        'Food photography for an Italian restaurant, menu showcase with high quality and premium visual photography for F&B industry',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Commercial restaurant photography, high quality food visuals for a food brand, italian cuisine photography, spaghetti photography, aglio olio pasta photography, red and vibrant theme of photography',
      url: 'https://mudrost.in/projectdetails/4'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_cover.jpg?alt=media&token=9604263a-3869-4a0a-a743-e357272aa524',
      bannerAltTxt:
        'Photo of a band holding up a spoonful of spaghetti aglio olio in a moody background, high contrast food photography for a restaurant in bangalore'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_1.jpg?alt=media&token=93c5e790-a933-4762-a971-95da4126497b',
        mediaAltTxt:
          'Interactive wide shot of spaghetti in a bowl, a chef holding red pepper shaker kept and sprinkling pepper on top of the spaghetti bowl'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_2.jpg?alt=media&token=0e7f04f3-833c-44eb-914e-d133374d59e2',
        mediaAltTxt:
          'Indulging premium quality photo of a person indulging on a bowl of aglio olio pasta, moody restaurant menu shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_3.jpg?alt=media&token=b0d73db6-2848-49b4-ba4a-13eab2fb8f46',
        mediaAltTxt:
          ' Indulging high quality visual of a person holding a pizza slice, cheese dripping out of the slice, moody menu food photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_4.jpg?alt=media&token=d3b65011-02ad-4326-8d7f-d0633e0b1029',
        mediaAltTxt: 'Sunlit vibe food photography of an italian delicacy, vibrant and fresh ingredients'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_5.jpg?alt=media&token=6c9e5d4f-396d-4fe6-8b7b-65823fb9482f',
        mediaAltTxt:
          'High quality indulgent food photography shot of an italian appetizer from a roma menu, high quality sharp image of a chef pouring olive oil to a dish'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Ffnb_roma_6.jpg?alt=media&token=cdf677c6-acf5-475f-9b2a-410cdb966a07',
        mediaAltTxt: 'Rich red and vibrant premium dessert photography for a restaurant in bangalore'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Froma%2Froma_thumbnail.webp?alt=media&token=8b157833-bce4-4db0-816e-98d7924f7cb5',
    thumbnailAltText:
      'Photo of a band holding up a spoonful of spaghetti aglio olio in a moody background, high contrast food photography for a restaurant in bangalore',
    meta: {
      brand: 'Roma',
      'photography & lighting': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'Roma serves you the taste of Italy on a platter. To showcase a brand that celebrates authenticity in every bite, we wanted to keep the images as real as possible. The magic of  natural light translated the soul of Roma into the frames.'
    }
  },
  {
    id: 5,
    category: 'foodandbeverages',
    title: 'Good Day',
    seoData: {
      title: 'Commercial photography campaign visuals for Soju drink by mudrost studio',
      description:
        'Commercial photography campaign for a beverage brand good luck. High quality images of soju drink in their rich green bottle. Recreating scenes across different setups. Studio shot images of the product.',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Beverage photography, commercial studio photography of soju the beverage drink, product photography, high quality studio shot beverage brand campaign',
      url: 'https://mudrost.in/projectdetails/5'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsoju%2Ffnb_soju_cover.jpg?alt=media&token=f0db081c-ff0f-4ab8-867b-aea1300c0ad4',
      bannerAltTxt:
        'Flatlay image of a soju good day bottle kept around sand to create an underwater set design for a campaign photography. Underwater beach themed shoot for a beverage brand'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsoju%2Ffnb_soju_1.jpg?alt=media&token=5b4a3390-88c1-44b5-ac5a-b41a31abf167',
        mediaAltTxt:
          'Creating a sunlit beach vibe with directed light source and prop styling to show the soju bottle as a giant attraction on a beach with mini props, blue background. Conceptual beverage brand shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsoju%2Ffnb_soju_2.jpg?alt=media&token=e3ec3fd3-51c4-4e15-be86-9248e65f95d7',
        mediaAltTxt:
          'Beach day with soju good day bottles, three bottles lined up arranged in a file, a hot sunny beach day photo campaign concept'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsoju%2Ffnb_soju_3.jpg?alt=media&token=ca4522a5-f193-491e-89e4-769750eed3fa',
        mediaAltTxt:
          'Top angle shot of soju bottles in a green background, Premium and minimal set design for a campaign shoot'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsoju%2Fsoju_thumbnail.webp?alt=media&token=1c9b50e4-a977-41f8-9f9f-dfd1697ed8a2',
    thumbnailAltText:
      'Flatlay image of a soju good day bottle kept around sand to create an underwater set design for a campaign photography. Underwater beach themed shoot for a beverage brand',
    meta: {
      brand: 'Good Day',
      'photography & lighting': 'vivek s k',
      'set design': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'Ever looked at something and felt instantly transported to another world? Soju does that for us, evoking relaxed, quality moments. We aimed to capture a visual escape that invites you to unwind. '
    }
  },
  {
    id: 6,
    category: 'foodandbeverages',
    title: 'TiLT',
    seoData: {
      title: 'High end campaign shoot with tilt wine bubbly rose by mudrost studio',
      description:
        'Premium high quality campaign showing the tilt wine in different setups using props and lighting to create variety campaign visuals ',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Beverage product photography, tilt wine product shoot, aesthetic fun colourful product styling for a beverage brand shoot, pink aesthetics with fresh ingredients, campaign shoot for a beverage brand, food photography in a studio',
      url: 'https://mudrost.in/projectdetails/6'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_cover.jpg?alt=media&token=f3439ce6-6244-422a-a420-7a9036cb44b0',
      bannerAltTxt:
        'Top angle shot of two wine cans by tilt, romantic set styling with pink silk fabric and cherries scattered on set, soft diffused highlights and shadows'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_1.jpg?alt=media&token=61ddd126-8d3a-4733-82ed-dbb9319181b7',
        mediaAltTxt:
          ' High quality image of a hand holding a bubbly rosè wine can, shot against a pink background and diffused light.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_2.jpg?alt=media&token=985a6402-5b8d-43fc-ae65-78c09d3ceac7',
        mediaAltTxt:
          'Commercial campaign photography of tilt wine can shot against a diffused pink backdrop, cherries standing up next to the can, refreshing beverage brand photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_3..jpg?alt=media&token=b93232ed-747d-4e1a-83bd-52f020e0ce92',
        mediaAltTxt: 'refreshing high quality beverage can photography with fresh cherries as a prop.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_4.jpg?alt=media&token=4e0a40ac-3b6c-49e2-86e0-5f7cac223943',
        mediaAltTxt: 'Editorial campaign visual of two wine cans, levitating campaign shot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ffnb_tilt_5.jpg?alt=media&token=22bcd09f-4319-43f6-bbe0-fd3f8d288e74',
        mediaAltTxt:
          'top angle shot of two wine cans in a pink backdrop, beverage commercial photography by a studio in bangalore'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftilt%2Ftilt_thumbnail.webp?alt=media&token=92524a81-7a61-4839-832f-a65e5336fcca',
    thumbnailAltText:
      'Top angle shot of two wine cans by tilt, romantic set styling with pink silk fabric and cherries scattered on set, soft diffused highlights and shadows',
    meta: {
      brand: 'TiLT',
      'photography & lighting': 'noorhanaz khatoon & vivek s k',
      'post production': 'noorhanaz khatoon',
      description:
        "We can safely say that this spec shoot was inspired by the product itself. The blush pink tone and funky font set the stage. We ran with a monochromatic theme and built on it, creating a gallery that's fresh, vibrant, and lively."
    }
  },

  {
    id: 9,
    category: 'products',
    title: 'Atomz Power',
    seoData: {
      title: 'Cinematic product videography by mudrost studio',
      description:
        'Product Videography, and demo visuals of Atomz, a EV charging unit. Bangalore based IOT company. VFX, Animation, product video advertisement, high end advertisement for product brands, branding for a IOT EV charging unit',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords: 'product videography, product video ad, videography, product demo video',
      url: 'https://mudrost.in/projectdetails/9'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fpro_atomz_cover.jpg?alt=media&token=7e95370d-147d-48db-8275-4d420523a47c',
      bannerAltTxt:
        'Image of a red EV charging unit shot against a black background with studio lighting, low key lighting highlight the subject, high quality image of the EV charger.'
    },
    media: [
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fpro_atomz_video.mp4?alt=media&token=fdc510bc-4a07-40a6-9ca7-24afaaa13a3c',
        mediaAltTxt:
          'High end advertisement quality video of a red EV charging unit, lighting effects reveal the logo and the product name, VFX and high quality content creation for a product brand'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fpro_atomz_1.jpg?alt=media&token=4b728507-8ee6-46c1-b0bb-41efbc135bad',
        mediaAltTxt:
          'front angle image of red EV charging unit for a brand called Atoms, high quality image of the EV charger, product photography of a EV Charger'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fpro_atomz_2.jpg?alt=media&token=c02aa211-e622-4b9e-ac64-8a5abb5f5593',
        mediaAltTxt:
          'Close Up shot of the charging port with a QR scanner and blue ring light of the EV charger, product demo photography of the details of the product'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fpro_atomz_3.jpg?alt=media&token=c0638b95-38e6-4845-b1d7-ddcf3f5b3c18',
        mediaAltTxt:
          'Wide angle shot of the red EV charger with a sleek red aesthetic design, photographed in a low key lighting against a black background, product demo visual'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fatmoz%2Fatomz_thumbnail.webp?alt=media&token=b32a240f-bf83-4113-a32b-377b42059027',
    thumbnailAltText:
      'Image of a red EV charging unit shot against a black background with studio lighting, low key lighting highlight the subject, high quality image of the EV charger.',
    meta: {
      brand: 'Atomz Power',
      director: ' thameem ansari',
      cinematographer: 'vivek s k',
      editor: 'vivek s k',
      colourist: 'noorhanaz khatoon',
      description:
        'Atomz brought us their EV charging series product, Elektron, and asked for a fun twist on the demo video. We were all in. To showcase the bold red of the product, we opted for a black background to highlight the product. After capturing the shots, we put our spin on the post-production, creating a dynamic demo for their futuristic product.'
    }
  },
  {
    id: 10,
    category: 'products',
    title: 'Fastrack',
    seoData: {
      title: 'Fastrack product photography by mudrost studio',
      description:
        'High quality commercial product photography of Fastrack watch. Editorial photography for Fastrack watch with smoke and low key lighting. Product visuals, campaign shot',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords: 'Campaign commercial product photography, Fastract watch photography, watch photography',
      url: 'https://mudrost.in/projectdetails/10'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffastrack%2Fpro_fastrack_cover.jpg?alt=media&token=29aea17a-563c-41a5-8642-c8a301ed92c8',
      bannerAltTxt:
        'Image of a red fastrack watch kept on a black reflective surface, high end product photography of the product in focus'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffastrack%2Fpro_fastrack_1.jpg?alt=media&token=678424dc-7717-4c88-8751-67e62b8f2e73',
        mediaAltTxt: 'Side view of a red fastrack watch kept on a black reflective surface, product photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffastrack%2Fpro_fastrack_2.jpg?alt=media&token=ecda2948-7ddf-49c3-9d11-79ee4ad9a274',
        mediaAltTxt:
          'Editorial watch photography of Fastack watch, campaign visuals with smoke, army band camouflage print fastrack watch'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffastrack%2Fpro_fastrack_3.jpg?alt=media&token=2e4de0a5-55d5-415d-b552-c30985d25ede',
        mediaAltTxt:
          'A high quality watch photography of camouflage print fastrack watch, black and khaki colour, high quality product photography of the watch.'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ffastrack%2Ffastrack_thumbnail.webp?alt=media&token=b8099a61-9ea7-4a5f-8b06-48fd077b3ddd',
    thumbnailAltText:
      'Image of a red fastrack watch kept on a black reflective surface, high end product photography of the product in focus',
    meta: {
      brand: 'Fastrack',
      '  photography & lighting': ' vivek s k',
      ' post production': ' vivek s k',
      description:
        'Embracing the spirit of reinvention, Fastrack inspired us to create visuals that are simple yet dramatic. We let the products shine by setting them against a sleek black background, giving them the spotlight they deserve.'
    }
  },
  {
    id: 11,
    category: 'products',
    title: 'Inditrunk - Coffee',
    seoData: {
      title: 'Inditrunk coffee advertisement by mudrost studio',
      description:
        'Cinematic campaign advertisement shoot by mudrost studio, product and e-commerce website promotional campaign shoot, story oriented ad film video, coffee making video, filter coffee making video',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'ad film creation, campaign video shoot with professional light and crew, high end commercial story oriented videography , filter coffee making video',
      url: 'https://mudrost.in/projectdetails/11'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Fpro_indcoffee_cover.jpg?alt=media&token=9a02c8cc-d77f-4d6c-aba2-56857b4eaaf8',
      bannerAltTxt:
        'High quality photo of a girl pouring hot water on top of a filter coffee maker, copper tumbler with hot water poured on a coffee filter coffee maker. '
    },
    media: [
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Fpro_inditrunk_coffee_video%20.mp4?alt=media&token=7eba82be-b09f-4773-8be6-c1e058772ce9',
        mediaAltTxt:
          'High end ad video of a girl wearing a yellow top missing the taste of her homegrown filter coffee and reminiscing it. Film of nostalgia and love for filter coffee. Authentic taste of filter coffee. Story oriented ad filmmaking'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Fpro_inditrunk_coffee_1.png?alt=media&token=2dfa161e-17fb-4388-b26c-43548609a552',
        mediaAltTxt: ' Ad quality visual - Close Up shot of a hand closing the lid of a copper filter coffee maker'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Fpro_indcoffee_2.jpg?alt=media&token=ad0668dd-f564-4f47-a9f2-335499fbe853',
        mediaAltTxt:
          'Ad quality visual - Close Up shot of a smiling girl wearing a grey kurta holding a copper tumbler with authentic filter coffee ready to sip on it.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Fpro_indcoffee_3.jpg?alt=media&token=bbc74c27-f25c-4616-9dd8-193b754ca8cd',
        mediaAltTxt:
          'Close Up shot of a smiling girl wearing a yellow sweatshirt holding a paper coffee cup with foreign coffee ready to sip on it.'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Finditrunk%2Finditrunk_coffee_thumbnail.webp?alt=media&token=75c13961-a8e0-4ef3-9714-308453b406b7',
    thumbnailAltText:
      'High quality photo of a girl pouring hot water on top of a filter coffee maker, copper tumbler with hot water poured on a coffee filter coffee maker. ',
    meta: {
      brand: 'Inditrunk',
      'creative producer': 'vivek s k',
      'writer and director': 'naveen tejaswi',
      cinematographer: 'darshan swaroop',
      art: 'sanskriti bist',
      editor: 'noorhanaz khatoon',
      music: 'vivan radhakrishna',
      colourist: 'siddarth sunil',
      description:
        'For Inditrunk’s “Dreaming Desi” campaign, the aim was to connect with the Indian diaspora craving a touch of home. Our goal was to evoke the cosy memory of a leisurely evening, savouring homemade filter coffee with a good book. With a passionate team and a touch of creativity, we crafted a visual story that wraps you in that comforting, nostalgic embrace.'
    }
  },
  {
    id: 12,
    category: 'products',
    title: 'Inditrunk - Diwali',
    seoData: {
      title: 'Inditrunk Diwali advertisement by mudrost studio',
      description:
        'Cinematic campaign advertisement shoot by mudrost studio, product and e-commerce website promotional campaign shoot, story oriented ad film video, diwali festivities  video, getting ready for diwali, lighting diyas',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'ad film creation, campaign video shoot with professional light and crew, high end commercial story oriented videography, diwali festivities, Indian festival of lights',
      url: 'https://mudrost.in/projectdetails/12'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Fpro_diwali_cover.jpg?alt=media&token=5913d6ea-f551-4556-9cfe-5e264e3415ba',
      bannerAltTxt:
        'High quality campaign ready visual of a young woman lighting copper diyas, smiling and enjoying diwali festivities, Indian festival of lights'
    },
    media: [
      {
        isVideo: true,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Fpro_inditrunk_diwali_video%20.mp4?alt=media&token=10c4128d-c107-40d7-b42b-fdf1f7163bf1',
        mediaAltTxt:
          'High end ad video of a girl lounging on a sofa and reminiscing Indian festival Diwali, wearing Indian attire and jewellery. '
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Fpro_diwali_1.jpg?alt=media&token=a57420f4-6c22-4cc0-bd3d-601aed1490ee',
        mediaAltTxt:
          'High quality image of a young woman standing in front of a mirror and looking at the reflection while adjusting her jewellery. '
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Fpro_diwali_2.jpg?alt=media&token=13048ffe-34e7-485c-be06-674f4cefa97a',
        mediaAltTxt:
          'Ad quality visual of a woman standing in front of the mirror looking at her reflection with a sad expression'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Fpro_diwali_3.jpg?alt=media&token=27476c25-b3d6-429d-9ca7-0a6ed750ae12',
        mediaAltTxt:
          'Ad quality visual, wide shot of a woman sitting on the sofa and lounging and looking at her phone in her living room'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Findi%20diwali%2Finditrunk_diwali_thumbnail.webp?alt=media&token=82164ddd-fd22-43cb-8c16-123eaeb0f077',
    thumbnailAltText:
      'High quality campaign ready visual of a young woman lighting copper diyas, smiling and enjoying diwali festivities, Indian festival of lights',
    meta: {
      brand: 'Inditrunk',
      'creative producer': 'vivek s k',
      'writer and director': 'naveen tejaswi',
      cinematographer: 'darshan swaroop',
      art: 'sanskriti bist',
      editor: 'noorhanaz khatoon',
      music: 'vivan radhakrishna',
      colourist: 'siddarth sunil',
      description:
        'For Inditrunk’s “Dreaming Desi” campaign, the goal was to connect with the Indian diaspora longing for a taste of home. We aimed to evoke nostalgia with our first film, leading to the concept of “Diwali.” With a talented team of technicians and artists, we brought this vision to life.'
    }
  },
  {
    id: 13,
    category: 'products',
    title: 'Mamaearth',
    seoData: {
      title: 'Comercial product photogrphy of mamaearth perfume by mudrost studio',
      description:
        'High end commercial visual of perfume bottle, shot in natural light, perfume photography of the brand mama earth',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        "commercial photography of mama earth's perfume bottle shot by mudrost studio, product photography, commercial product photography, natural light product photography",
      url: 'https://mudrost.in/projectdetails/13'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fmamaearth%2Fpro_mama_cover.jpg?alt=media&token=6af85f97-eb93-4b73-a09d-cb79ea67dab4',
      bannerAltTxt:
        "Mama earth's white musk perfume bottle kept on top of a green fabric, front angle wide shot of the setup, backlight shot of the perfume"
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fmamaearth%2Fpro_mama_1.jpg?alt=media&token=b1f7d6d7-ec2c-4b74-a712-6cd12c40ab37',
        mediaAltTxt:
          "commercial product photography of mama earth's white musk perfume bottle kept on a green net fabric, natural light shot and backlit with a soft bounce, product kept on a side profile"
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fmamaearth%2Fpro_mama_2.jpg?alt=media&token=6fe5865a-6715-48ae-ac50-57efbccffa9a',
        mediaAltTxt:
          "flatlay shot of a mama earth's white musk perfume range, kept on a green net fabric and shot in natural light, product photography for indian perfume brand"
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fmamaearth%2Fpro_mama_3.jpg?alt=media&token=fcc5783e-9498-4568-97c4-a7b07e62e752',
        mediaAltTxt:
          " side profile shot of mama earth's white musk perfume kept on a net fabric, a yellow crystal charm hanging from top and next to the bottle, high key lighting, backlit and soft bounce"
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fmamaearth%2Fmama_earth_thumbnail.webp?alt=media&token=bf878deb-0063-4541-af0d-ba5d8767d45b',
    thumbnailAltText:
      "Mama earth's white musk perfume bottle kept on top of a green fabric, front angle wide shot of the setup, backlight shot of the perfume",
    meta: {
      brand: 'Mamaearth',
      'photography & lighting': 'vivek s k and noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'This shoot turned into a creative challenge to see what we could do with limited resources. Shot entirely with natural light, we drew inspiration from Mamaearth’s subtle musky tones and elegant packaging. Our mission was to capture that natural elegance in every shot, letting the beauty of simplicity shine through.'
    }
  },
  {
    id: 14,
    category: 'products',
    title: 'Minimalist',
    seoData: {
      title: 'Product photography of minimalist hair serum by mudrost studio',
      description:
        'High end commercial visual of minimalist hair serum, shot with directed studio light, artistic choice of crafting light, product photography of skincare brand minimalist',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'product photography, product visuals, commercial product photography, artistic product photography, studio light product photography',
      url: 'https://mudrost.in/projectdetails/14'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fminimalist%2Fpro_minimalist_cover.jpg?alt=media&token=3ecf528a-9fe6-483c-8e06-79000e74c616',
      bannerAltTxt:
        'product photography of skincare brand minimalist, photo of the product kept on top of a stone in the left side and on the right, the shadow on the product'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fminimalist%2Fpro_minimalist_1.jpg?alt=media&token=05614604-65df-4f12-872c-2cf44cecb01d',
        mediaAltTxt:
          'Product photography of hair serum kept on top of the stone, a speck of light over the textured background and two stones kept on the background'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fminimalist%2Fpro_minimalist_2.jpg?alt=media&token=02765d8e-962b-4dd3-8df3-7607df32f515',
        mediaAltTxt:
          'Commercial product photography of a skincare product, minimalist hair serum kept on a stone and reflection seen on a mirror. Balanced even toned lighting'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fminimalist%2Fpro_minimalist_3.jpg?alt=media&token=fff11f4c-bc84-4b27-93c0-eaac399b7119',
        mediaAltTxt:
          'Stylistic product photography of a skincare brand minimalist, studio lighting and highlight on the product.'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fminimalist%2Fminimalist_thumbnail.webp?alt=media&token=ed1cc5a1-1b36-4066-ac9e-08f1325017ec',
    thumbnailAltText:
      'product photography of skincare brand minimalist, photo of the product kept on top of a stone in the left side and on the right, the shadow on the product',
    meta: {
      brand: 'Minimalist',
      'photography & lighting': 'vivek s k & noorhanaz khatoon',
      'set design': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'For this product, our goal was to reflect the brand’s philosophy of transparency. We used natural elements to create a calm, serene look that complements the packaging. Mirrors and their reflections echoed the brand’s ideology, while focused lighting drew attention to the product in its setting.'
    }
  },
  {
    id: 15,
    category: 'products',
    title: 'Noise',
    seoData: {
      title: 'Product photography of noise smart watch by mudrost studio',
      description:
        'High end commercial product photography of noise smartwatch, minimal set design and product styling. Directed studio lighting for product photography',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'product photography of commercial smartwatch, studio lighting product photography, minimal set design and styling for product photography.',
      url: 'https://mudrost.in/projectdetails/15'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fnoise%2Fpro_noise_cover.jpg?alt=media&token=a7ea0f14-a897-4cfb-b72c-b38dc2558abd',
      bannerAltTxt:
        'High end commercial photography of noise smartwatch, close up shot of the smartwatch screen and belt with logo on a black background'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fnoise%2Fpro_noise_1.jpg?alt=media&token=c8cc2369-6814-4543-ab8f-3433e691483d',
        mediaAltTxt:
          'Wide shot of noise smartwatch kept on a black background. The specs of the product seen on the screen of the watch'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fnoise%2Fpro_noise_2.jpg?alt=media&token=c9dc4065-bd5e-411c-80df-f89683962479',
        mediaAltTxt: 'Wide shot of the smartwatch kept on top of a black background, side view of the product'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fnoise%2Fpro_noise_3.jpg?alt=media&token=b230f423-aef4-43e2-910b-47bf63efb465',
        mediaAltTxt:
          'Extreme close up shot of black noise smartwatch, high end commercial product detail shot showing the logo'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fnoise%2Fnoise_thumbnail.webp?alt=media&token=64874d95-58b9-4510-aba4-ea8d2db84db5',
    thumbnailAltText:
      'High end commercial photography of noise smartwatch, close up shot of the smartwatch screen and belt with logo on a black background',
    meta: {
      brand: 'Noise',
      'photography & lighting': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        "When noir met noise, we got a gallery that's minimal, moody, and sleek. For a brand that upholds simplicity in its design, we wanted to keep the set design minimal, which would allow us to highlight the details of the product. "
    }
  },
  {
    id: 16,
    category: 'products',
    title: 'Plum',
    seoData: {
      title: 'Skincare brand product photography by mudrost studio',
      description:
        'High quality commercial product photography of serum by plum. Studio product photography for marketing collateral. D2C brand product photography',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'product photography, commercial product photography, studio product photography, skin care brand product photography, high end product styling and shoot',
      url: 'https://mudrost.in/projectdetails/16'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fplum%2Fpro_plum_cover.jpg?alt=media&token=0b7fbd84-83f4-440b-a183-38256c7b950e',
      bannerAltTxt:
        'Product photography of skincare brand, the dropper of the serum squeezing product out of the dropper, bottle cap open shot of skincare product '
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fplum%2Fpro_plum_1.jpg?alt=media&token=a40c08e6-eb30-4e01-8e2e-1239a53f94f1',
        mediaAltTxt:
          'Product photography of plum skincare serum, serum kept on top of a glass and the blue bottle with a directed studio light kept against a blue background. water drop falling off the glass slab'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fplum%2Fpro_plum_2.jpg?alt=media&token=da254887-3a28-45a7-8bb1-a2239103a9ac',
        mediaAltTxt:
          'Plum skincare bottle kept on top of a glass slab, multiple water droplets are falling from the slab. Minimal product styling, monochromatic but highlighted set design, water themed shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fplum%2Fpro_plum_3.jpg?alt=media&token=f2b40414-3677-4f3b-ba89-dcd4a2edb732',
        mediaAltTxt:
          'Low key lighting to highlight the skincare bottle kept in front of the mirror, reflection of plum skin care product seen on the mirror. The bottle is kept on top of a stone.'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fplum%2Fplum_thumbnail.webp?alt=media&token=66a5b86e-2ca8-4d0b-9921-4f5d3aa0b543',
    thumbnailAltText:
      'Product photography of skincare brand, the dropper of the serum squeezing product out of the dropper, bottle cap open shot of skincare product ',
    meta: {
      brand: 'Plum',
      'photography & lighting': 'vivek s k & noorhanaz khatoon',
      'set design': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'Plum focuses on goodness that delivers, blending science with nature. To bring this to life, we created a set that incorporated natural elements to complement the product’s vibrant blues. Water, with its transparency and ability to play with light, was the perfect match.'
    }
  },
  {
    id: 17,
    title: 'Sukh',
    category: 'products',
    seoData: {
      title: 'Product photography for a catalogue hamper shoot by mudrost studio',
      description:
        'High quality, print ready commercial studio product photography of gift hampers in different setups. From grooming products to chocolates and wine. Gift hamper photography.',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        "Gift hamper photograph, product photography, commercial product photography, commercial photography styling and arrangement, commercial studio setup and product styling, product styling for chocolates and wine, product styling for men's grooming product.",
      url: 'https://mudrost.in/projectdetails/17'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_cover.jpg?alt=media&token=536f6968-f3eb-4e13-a5ed-2dd7e3e79d9c',
      bannerAltTxt:
        'Product photography of a period gift hamper with a bamboo basket and inside that are chocolates by smoor, period heating pads by NUA, chamomile tea, shot in controlled studio environment replicating the winter sun'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_1.jpg?alt=media&token=bbc336c6-8e43-4d47-bd24-edc4a34a38de',
        mediaAltTxt:
          "Commercial product photography of gift hamper which is made out of bamboo and has mason and co's chocolates, octavius tea, Turmeric latte powder and decorated with fresh fruits on baskets and bowls"
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_2.jpg?alt=media&token=2cd82291-9f0d-4b68-a3d0-20ce851915db',
        mediaAltTxt:
          'High quality product photography of a gift hamper that has talisva white wine, manam dark chocolate, jams and cooking oil. Styled with blueberries and raspberries.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_3.jpg?alt=media&token=bf83ee75-93e7-4279-88b9-9b44975ec029',
        mediaAltTxt:
          'Commercial product photography of a gift hamper for woman, pink and soft aesthetics in set styling and decor, the hamper has rosè, chocolate and is decorated with strawberries.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_4.jpg?alt=media&token=a598a475-ed62-4519-938a-a73cbe2e186c',
        mediaAltTxt:
          'Product photography of gift hamper that has Bombay sweet shop products along with bakeree products all added to the hamper. A hand of a person interacting with the hamper'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_5.jpg?alt=media&token=c78afd5a-7530-42c4-bc41-a63551a58154',
        mediaAltTxt:
          'High quality studio shot of two people holding a gift from either side. Controled studio lighting with flash and brand name highlighted'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fpro_sukh_6.jpg?alt=media&token=a8f95ec2-c08d-48ed-a0c0-20e771f1eb56',
        mediaAltTxt:
          "High quality of gift hamper for men which has a tech organizer, Bath and Body works ocean line of product's photography, Mason and Co's dark chocolate."
      }
    ],

    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fsukh%2Fsukh_thumbnail.webp?alt=media&token=d7580f3b-0be9-4b98-a1cf-0dd601355912',
    thumbnailAltText:
      'Product photography of a period gift hamper with a bamboo basket and inside that are chocolates by smoor, period heating pads by NUA, chamomile tea, shot in controlled studio environment replicating the winter sun',
    meta: {
      brand: 'Sukh',
      'photography & lighting': 'vivek s k & noorhanaz khatoon',
      'set design': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'When Sukh approached us, we were excited to dive into a project with such a diverse range of products. For a company that wraps up memories and happiness, we aimed to keep the lighting warm and inviting. We enjoyed creating unique sets and experimenting with different moods.'
    },
    clientQuote: {
      clientName: 'Payal Menon',
      designation: 'Founder, Sukh',
      quote:
        'We had the pleasure of working with mudrost for our first product shoot when we started our gifting business. From the start, Vivek and Noor impressed us with their professionalism and dedication. <br />Despite working from morning to night, they remained patient and enthusiastic throughout. Even on a day with minimal natural light, they managed to achieve the perfect lighting in just a couple of minutes.<br />We highly recommend mudrost and would love to work with this talented team again'
    }
  },

  {
    id: 18,
    category: 'products',
    title: 'Titan - Skinn',
    seoData: {
      title: 'Commercial product photography of Titan Skinn perfume range by mudrost studio',
      description:
        'Commercial product photography of titan Skinn, studio product photography and styling in different setups. Minimal product photography for a classy look',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Product photography of titan skinn, commercial studio product photography, high end product styling and lighting. Perfume photography in a dark background, product photography in a white background',
      url: 'https://mudrost.in/projectdetails/18'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftitan%2Fpro_titan_cover.jpg?alt=media&token=e6854155-143d-44ba-a58e-25e036daab83',
      bannerAltTxt:
        'High quality product photography of skinn by titan on a black background, targeted low key lighting that shows the bottle and brand name'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftitan%2Fpro_titan_1.jpg?alt=media&token=9b4e7198-241d-463c-8d17-ad4741d60b33',
        mediaAltTxt:
          'Commercial product photography of perfume bottle in a white background. Creative product photography, minimal and creative styline. A shadow outline of a hand reaching out to a perfume bottle'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftitan%2Fpro_titan_2.jpg?alt=media&token=c8acfb68-52a0-47e9-8731-4c9b8a457a1c',
        mediaAltTxt:
          'Studio shot product photography of titan skinn bottle kept on a white background. High key lighting product photography and styling'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftitan%2Fpro_titan_3.jpg?alt=media&token=1062171f-5cc5-464c-b610-d2e9b7388dde',
        mediaAltTxt:
          'Flatlay image of titan skinn bottle with a black background kept on a water surface. lighting highlighted shows the ripples in the water. Showing movement and rhythm in the image '
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Ftitan%2Ftitan_thumbnail.webp?alt=media&token=f3cf7501-44b0-4dd2-9d1b-7f42df18f23a',
    thumbnailAltText:
      'High quality product photography of skinn by titan on a black background, targeted low key lighting that shows the bottle and brand name',
    meta: {
      brand: 'Titan - Skinn',
      'photography & lighting': 'vivek s k',
      'set design': 'vivek s k',
      'post production': 'noorhanaz khatoon',
      description:
        'This shoot was inspired by our love for the packaging design. The earthy hues and crystal top of the product made it an intriguing subject. Our aim was to simply enjoy showcasing the packaging in its best light.'
    }
  },
  {
    id: 19,
    category: 'products',
    title: 'Ryka',
    seoData: {
      title: 'Floral jewelry elegant product photoshoot by mudrost studio ',
      description:
        'Commercial product photography for a surreal and enchanting campaign theme. Jewelry shoot for a floral jewellery brand in Guwahati Assam. Studio shoot and product styling.',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Commercial product photography, elegant product styling and set styling for a jewellery brand, flower and nature theme setup, campaign shoot done in a studio in Bangalore. ',
      url: 'https://mudrost.in/projectdetails/19'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fpro_ryka_banner.jpg?alt=media&token=fc795bd5-e803-4cae-970f-180fc466409a',
      bannerAltTxt: 'Professional campaign image woman wearing a floral jewelry bracelet. Studio product photography  '
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_1.jpg?alt=media&token=309651e1-8629-4dbc-aa5e-e4f9b6369b4b',
        mediaAltTxt:
          'Product photography of a woman wearing a floral ring and holding a pink rose flower. Standing against a pink background. High end product photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_2.jpg?alt=media&token=45b524b7-0778-4003-b945-75cbbf794671',
        mediaAltTxt:
          'Image of a woman wearing a floral bracelet and holding a yellow flower. Set styling with a yellow and white aesthetic. Professional photography for a jewellery brand'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_3.jpg?alt=media&token=4c399442-e436-4c88-b179-dc099970703b',
        mediaAltTxt:
          'Creative photo campaign visual of a floral jewellery ring, a hand model wearing a floral ring and touching water on a tub filled with rose petals. High key lighting'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_4.jpg?alt=media&token=0eb6e66b-ecac-4614-b4ee-1d3636893aa4',
        mediaAltTxt:
          'Artistic campaign photography of a woman wearing a floral ring and holding her hand up amongst flower and branches. Garden themed shoot.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_5.jpg?alt=media&token=0fa32e83-8bcc-498d-bfb0-effea5b4cc66',
        mediaAltTxt:
          'Artistic campaign photography of a woman wearing a floral ring and holding a branch of purple flower amongst flower and branches. Garden themed shoot.'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_6.jpg?alt=media&token=978f60d9-2180-4760-ba25-8e9163f6dc60',
        mediaAltTxt:
          'Commercial product photography campaign for a floral jewellery brand. A woman wearing a blue floral earring and is surrounded by blue flowers. '
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_7.jpg?alt=media&token=09760c46-1291-41f5-a7ba-ea483506b505',
        mediaAltTxt:
          ' Macro shot of a floral jewellery bracelet, product photography for commercial brand image creation. '
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_8.jpg?alt=media&token=82f6bd1a-b574-48ea-82d2-e5f61086e66f',
        mediaAltTxt: 'Close Up shot of a floral ring kept on top of a tree bark. Detailed shot of the product'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_9.jpg?alt=media&token=5b875ff8-0ff3-41c3-9f75-56dca7464ec5',
        mediaAltTxt:
          'Top down macro shot of the floral ring kept on a tea bark, detailed shot of the product, whimsical nature themed set styling for a product shoot campaign. '
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Fryka%2Fryka_thumbnail.jpg?alt=media&token=73a46f66-deff-4c42-8287-3258f0c76a48',
    thumbnailAltText:
      'Professional campaign image woman wearing a floral jewelry bracelet. Studio product photography ',
    meta: {
      brand: 'Ryka',
      'photography & lighting': 'vivek s k',
      'creative direction and styling': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon',
      description:
        'When Ryka approached us, their delicate floral jewelry sparked the idea of a "Garden of Wishes." We envisioned each piece as a small, graceful wish blossoming in a serene natural setting. Our goal was to create a space where the beauty of their jewelry could quietly merge with the gentle rhythm of nature, bringing to life a place where wishes grow.'
    }
  },
  {
    id: 20,
    category: 'foodandbeverages',
    title: 'Rivaayat',
    seoData: {
      title: 'High Quality Biryani Food Photography by murost studio ',
      description:
        'High quality food photography for a cloud kitchen, nawabi themed biryani shoot on a dark background with traditional copper utensils',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'biryani photography, concept food photography, commercial studio photography by a creative studio in Bangalore, moody dark and rich food styling for a cloud kitchen brand in Bangalore, food styling for commercial shoot, food photography for a cloud kitchen',
      url: 'https://mudrost.in/projectdetails/20'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Fbanner_fnb_rivaayat.jpg?alt=media&token=b9cdd812-3dd1-43e7-bad3-5f713a8a0095',
      bannerAltTxt:
        'Food photography of chicken Biryani kept on a handi, 45 degree angle shot of chicken biryani kept on a textured base and dark background.'
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_1.jpg?alt=media&token=7f85ed68-a59a-4e50-97a1-d3ab4c04d7ca',
        mediaAltTxt: 'Wide shot of paneer biryani kept on a styled moody nawabi style set, moody biryani photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_2.jpg?alt=media&token=8e660962-fdd0-4ad9-b37a-17c927e7b8ca',
        mediaAltTxt:
          'Wide shot of mutton biryani kept at the centre, next to it is raita and gulab jamun, moody rich food styling for a cloud kitchen shoot'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_3.jpg?alt=media&token=687f9869-a6f7-4b5f-abde-29884c50ff7c',
        mediaAltTxt:
          'High quality listing image of a Indian paneer starter with a nawabi and a rich flavour showcase, e-commerce food photography'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_4.jpg?alt=media&token=93d250a1-9113-4385-a536-bd2610bdf698',
        mediaAltTxt: 'Food photography for swiggy, zomato and other ecommerce platforms for a Indian cloud kitchen'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_5.jpg?alt=media&token=5540a3fe-7162-4a72-9952-6d892fe62607',
        mediaAltTxt:
          'Image of a appetizer kept on a coffer plate,  Bangalore based restaurant providing photography services for a cloud kitchen'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_6.jpg?alt=media&token=8a436ed5-3df7-4bfc-a806-2e8ec24edf6f',
        mediaAltTxt: 'Chicken main course photography by a bangalore based food photography studio'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2Frivaayat%2Ffnb_rivaayat_thumbnail.jpg?alt=media&token=18911ef0-045a-40a4-8cb9-87ef855b64f2',
    thumbnailAltText:
      'Food photography of chicken Biryani kept on a handi, 45 degree angle shot of chicken biryani kept on a textured base and dark background.',
    meta: {
      brand: 'Rivaayat',
      'photography & lighting': 'vivek s k',
      'creative direction and styling': 'noorhanaz khatoon',
      'post production': 'vivek s k and noorhanaz khatoon',
      description:
        'Rivaayat is a quiet tribute to Hyderabad’s culinary traditions. The photos focus on the simple elegance of Nawabi flavors, with vintage-inspired settings that let the food speak for itself. The aim was to create timeless images that reflect the true essence of the menu.'
    }
  },
  {
    id: 21,
    category: 'foodandbeverages',
    title: 'Anand Mullu Murukku',
    seoData: {
      title: 'Commercial photography of south Indian snack from Anand Sweets by mudrost studio',
      description:
        'Commercial campaign shoot for Anand Sweets recreating a evening coffee ritual in a traditional south Indian style, filter coffee with mullu murukku',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Commercial campaign shoot for a FMCG brand Anand Sweets, high quality food photography for a south Indian delicacy, south Indian traditional snack with filter coffee',
      url: 'https://mudrost.in/projectdetails/21'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Fbanner_fnb_mullu_muruku.jpg?alt=media&token=f7f4d497-78dc-4140-a666-1187b2781dd8',
      bannerAltTxt:
        "Flatlay shot of Anand Sweet's mullu murukku placed inside a tiffin box, a hand comes and picks up one of the murukku, indian south Indian snack photography"
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Ffnb_mullu_muruku_1.jpg?alt=media&token=618c88b1-5988-4490-876b-a5482934fafd',
        mediaAltTxt: 'flatlay shot of South Indian snack for Anand Sweets, studio shoot for a commercial campaign'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Ffnb_mullu_muruku_2.jpg?alt=media&token=f30b65ba-e39d-49f2-8085-2057b51a588e',
        mediaAltTxt:
          'Lifestyle shot of traditional south Indian snacks and filter coffee photography for an FMCG brand Anand Sweets'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Ffnb_mullu_muruku_3.jpg?alt=media&token=8805053e-fe4f-400d-a043-acaedc85cdd9',
        mediaAltTxt: "closeup shot of Anand sweet's mullu murukku kept on a copper tiffin box"
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Ffnb_mullu_muruku_4.jpg?alt=media&token=3afef442-7908-437d-995e-a6c7d2f9700b',
        mediaAltTxt:
          "Flatlay shot of Anand's Mullu murukku south Indian snacks with the packaging and styling for a campaign shoot"
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Mullu%20Muruku%2Fmuruku_anand_thumbnail.jpg?alt=media&token=bec417ab-0d80-4393-a2f1-25b53eda9274',
    thumbnailAltText:
      "Flatlay shot of Anand Sweet's mullu murukku placed inside a tiffin box, a hand comes and picks up one of the murukku, indian south Indian snack photography",
    meta: {
      brand: 'Anand Sweets',
      'photography & lighting': 'vivek s k',
      'creative direction and styling': 'noorhanaz khatoon',
      'post production': 'vivek s k',
      description:
        'For a brand known for premium Indian sweets, it was essential to preserve their elegance and traditional essence. With the product, Mullu Murukku, we aimed to evoke nostalgia by capturing the warmth of an evening coffee scene.'
    }
  },
  {
    id: 22,
    category: 'foodandbeverages',
    title: 'Anand Almond Pista',
    seoData: {
      title: 'Commercial campaign photography for FMCG brand Anand sweets by mudrost studio',
      description:
        'High impact commercial photography for Anand sweets for their almost pista biscuits, recreating a cozy afternoon tea time at home',
      itempropDescription:
        'Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.',
      keywords:
        'Anand Sweets brand product photography, biscuits photography , clean and minimal set styling for a FMCG campaign shoot, food photography styling for biscuits, photography for a sweets brand in India, bangalore based product and food photography studio',
      url: 'https://mudrost.in/projectdetails/22'
    },
    banner: {
      isVideo: false,
      bannerSrc:
        'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Almond%20Pista%2Falmond_pista_banner.jpg?alt=media&token=838217e7-1ae9-42f7-9119-d8bcef3b90dd',
      bannerAltTxt: 'High end campaign photography for a biscuit product for Anand Sweets styled with tea '
    },
    media: [
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Almond%20Pista%2Fanand_almond_pista_4.jpg?alt=media&token=95cb5221-ecf1-4cde-9b25-e37402983ff1',
        mediaAltTxt:
          ' Lifestyle studio shot photography of Indian biscuits kept on the table, product styling for indian cookies'
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Almond%20Pista%2Fanand_almond_pista_5.jpg?alt=media&token=ed5601cb-162f-4f9a-8b5c-ed75c54af163',
        mediaAltTxt:
          "Minimal, studio shot high quality image of Anand's almond pista cookies, recreating natural light indoors in a controlled studio environment"
      },
      {
        isVideo: false,
        src: 'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Almond%20Pista%2Fanand_almond_pista_3.jpg?alt=media&token=876976d1-aca6-4e75-8b1c-61aa05a5b95c',
        mediaAltTxt:
          'Top view detail shot of the cookies being kept on top of a table, texture and detail of cookies seen, high quality campaign shot of packaged food in Bangalore'
      }
    ],
    thumbnail:
      'https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/products%2FAnand%20Almond%20Pista%2Ffnb_almondpista_thumbnail%20(1).jpg?alt=media&token=287342f1-231c-4659-84f6-17928ab192b4',
    thumbnailAltText: 'High end campaign photography for a biscuit product for Anand Sweets styled with tea ',
    meta: {
      brand: 'Anand Sweets',
      'photography & lighting': 'vivek s k',
      'creative direction and styling': 'noorhanaz khatoon',
      'post production': 'noorhanaz khatoon and vivek s k',
      description:
        "Anand takes pride in delivering the taste of royal India, with recipes crafted for a modern audience. To reflect this essence and highlight their premium snacking range, we created a refined yet simple 'chai time' sequence featuring Anand's almond pista cookies."
    }
  }
];
